export default {
    type: 'numeric',
    format: {
        decimals: 2,
        min: 0,
        currency: true
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: { },
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Average Play Worth',
        category: ['User', 'Plays'],
        description: 'The estimated value of a game divided by plays.',
        summarise: {
            prefix: 'Average play worth'
        }
    },
    rules: {
        linked: [],
        legacy: ['worth.play']
    }
}